<template>
  <span class="chevron-icon" :class="`chevron-icon--${position}`" />
</template>
<script>
export default {
  name: 'ChevronIcon',
  props: {
    position: {
      type: String,
      default: 'bottom'
    }
  }
}
</script>
<style lang="scss" scoped>
.chevron-icon {
  &:before {
    border-style: solid;
    border-width: 1px 1px 0 0;
    border-color: #000;
    content: "";
    display: inline-block;
    height: 8px;
    position: relative;
    transform: rotate(-45deg);
    width: 8px;
  }

  &--right {
    &:before {
      left: 0;
      transform: rotate(45deg);
    }
  }

  &--bottom {
    &:before {
      top: 0;
      transform: rotate(135deg);
    }
  }

  &--left {
    &:before {
      left: 0.25em;
      transform: rotate(-135deg);
    }
  }
}
</style>
